import { useTranslation } from "@next-platform/client-common-core";
import { useMemo } from "react";

export type DiscoverChatbotCardLabels = {
  readonly favorite: string;
  readonly favorited: string;
  readonly more: string;
  readonly recommended: string;
};

/** Resolves the visible and control copy for the Discovery chatbot card. */
const useDiscoverChatbotCardLabels = (): DiscoverChatbotCardLabels => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      favorite: t("chatbotCard:tooltip.like", "Add to favorites"),
      favorited: t("chatbotCard:tooltip.unlike", "Remove from favorites"),
      more: t("chatbotCard:tooltip.moreActions", "More options"),
      recommended: t("chatbotCard:badge.forYou"),
    }),
    [t],
  );
};

export default useDiscoverChatbotCardLabels;
